// key: ukraine translation
export default {
	'Phone must be verified': 'Телефон повинен бути підтверджений'
}
